import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import queryString from 'query-string';
import './LogIn.css';

import ForgotPassword from '../components/ForgotPassword';

import { withFirebase } from '../firebase';
import * as ROUTES from '../constants/routes';

const LogIn = () => (
  <div>
    <div>
      <img
        className="LogIn-logo"
        src={process.env.PUBLIC_URL + '/img/logo.png'}
        alt="logo"
      />
      <h1 className="LogIn-title">SONA Account Registration &amp; Login <a href="http://sonad.io/instruction.html#edit" target="_blank" rel="noopener noreferrer" className="Help">?</a></h1>
      <h2 className="LogIn-subtitle">
        Don't have an account? To register, download the SONAD app for <Link to="https://itunes.apple.com/us/app/sonad/id1090538431?mt=8">iPhone</Link> or <Link to="https://play.google.com/store/apps/details?id=com.app.sonad.sonad">Android</Link>.
      </h2>
      <LogInForm />
    </div>
  </div>
);

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
  isOpen: false,
};

class LogInFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };


  }

  onSubmit = event => {
    const { email, password } = this.state;
    let params = queryString.parse(this.props.location.search);
    let target = params.target
    let {firebase} = this.props
    firebase
      .doSignInWithEmailAndPassword(email, password)
      .then((user_cred) => {
        console.log(user_cred)
        this.setState({ ...INITIAL_STATE }, () => {
          // Check if profile filled
          this.props.firebase.user(user_cred.user.uid).once('value', snapshot => {
            let user_val = snapshot.val()
            let profile_filled = user_val != null
            if (!profile_filled) {
              console.log('User profile (in datastore) not found, creating...')
              // Create user object in datastore, then redirect to profile
              this.props.firebase.user(user_cred.user.uid).set({
                email: user_cred.user.email
              }).then(() => {
                this.props.history.push(ROUTES.PROFILE);
              })
            } else {
              // Have profile, check email verification
              let email_verified = firebase.email_verified()
              if (email_verified) {
                if (target != null) window.location.replace(target)
                else this.props.history.push(ROUTES.HOME)
              } else this.props.history.push(ROUTES.PROFILE);
            }
          });
        });

      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const { email, password, error } = this.state;
    return (
      <div>
        <form onSubmit={this.onSubmit} className="LogIn-form">
          <input
            name="email"
            value={email}
            onChange={this.onChange}
            type="email"
            placeholder="Email"
            required
          />
          <input
            name="password"
            value={password}
            onChange={this.onChange}
            type="password"
            placeholder="Password"
            required
          />
          {error && <p>{error.message}</p>}
          <div className="LogIn-form--btn-container">
            <button type="submit">Log in</button>
            <span>or</span>
            <button
              onClick={this.toggleModal}
              style={{ backgroundColor: '#123776' }}
              type="button"
            >
              Forgot password
            </button>
          </div>
        </form>
        <ForgotPassword show={this.state.isOpen} onClose={this.toggleModal}>
          `Here's some content for the modal`
        </ForgotPassword>
      </div>
    );
  }
}

const LogInForm = compose(
  withRouter,
  withFirebase
)(LogInFormBase);

export default LogIn;

export { LogInForm };
